import { useQueryClient } from "@tanstack/react-query";
import { getQueryKey } from "@trpc/react-query";
import { trpc } from "../trpc";
import { Approval } from "@zapier/bff";

export function useCancelApproval() {
  const queryClient = useQueryClient();

  const approvalKey = getQueryKey(trpc.approval.approvals, undefined, "any");

  const mutation = trpc.approval.cancel.useMutation({
    // Callback to handle optimistic updates in RQ cache
    onMutate: ({ id, zapId, type }) => {
      queryClient.cancelQueries({ queryKey: approvalKey });

      queryClient.setQueriesData(
        {
          queryKey: approvalKey,
          type: "active",
        },
        (old: { approvals: Approval[] } | undefined) => {
          if (!old?.approvals) {
            return old;
          }

          // Remove the cancelled approval from the approvals results array
          return {
            ...old,
            approvals: old.approvals.filter(
              (approval) =>
                !(
                  approval.id === id &&
                  approval.type === type &&
                  approval.zapId === zapId
                ),
            ),
          };
        },
      );
    },
    // Callback to handle cache invalidation after mutation is completed
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: approvalKey,
        refetchType: "all",
      });

      const myRequestsKey = getQueryKey(
        trpc.approval.requests,
        undefined,
        "any",
      );
      queryClient.invalidateQueries({
        queryKey: myRequestsKey,
        refetchType: "all",
      });
    },
  });

  return {
    cancelApproval: mutation.mutate,
    isLoading: mutation.isPending,
  };
}
